<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getLanguageChanged">{{refresh()}}</div>
        
        <v-card v-if="$store.getters.getLanguageList">     
            <div v-if="getShowHelpEvent">{{showHelp()}}</div>
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="needInit">{{initData()}}</div> 
            <div v-if="myContent">
                <div v-html="myContent.content"></div>
                <v-radio-group v-model="selectedIndex" :mandatory="false">
                    <div v-for="(item, index) in myContent.answer_list" :key="index" >
                    <v-radio :label="item.answer" :value="index" :color="styleObject.color" @change="resetEvaluatedData()"></v-radio>
                    <p v-if="index == selectedIndex && feedback != null " v-bind:style="styleObject">{{feedback}}</p>
                    </div>
                </v-radio-group>
            </div>
        </v-card>

        <v-card v-if="showMyHelp">
            <div v-html="myContent.help">
            </div>
            <v-btn @click="showMyHelp = false">Hide Help</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                myGlobals: null,
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                selectedIndex: null

        }
    },
    computed: 
        mapGetters([
                    'getShowHelpEvent',
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguagePrimary',
                    'getLanguageChanged'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        initData() {
            this.needInit = false         
            this.$store.commit('setFeedback', null)   
            this.myContent = JSON.parse(this.dcontent.data.content)
            this.myGlobals = JSON.parse(this.dcontent.data.globals)

            // shuffle
            for(let i=0; i < this.myContent.answer_list.length; i++) {
                const rand = Math.floor(Math.random() * this.myContent.answer_list.length);
                [this.myContent.answer_list[i], this.myContent.answer_list[rand]] = [this.myContent.answer_list[rand], this.myContent.answer_list[i]];
                [this.myGlobals.ratings[i], this.myGlobals.ratings[rand]] = [this.myGlobals.ratings[rand], this.myGlobals.ratings[i]];
            }                        
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            this.feedback = this.myContent.answer_list[this.selectedIndex].feedback
            if (this.myGlobals.ratings[this.selectedIndex] == 100)  {
                this.styleObject.color = 'green'
                if (this.myContent.answer_list[this.selectedIndex].feedback == '') this.feedback = 'Correct!'
                return
            }
            this.styleObject.color = 'red'
            if (this.myContent.answer_list[this.selectedIndex].feedback == '') this.feedback = 'Sorry, bad answer.'
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            for(var i = 0; i < this.myGlobals.ratings.length; i++) {
                if (this.myGlobals.ratings[i] == 100) {
                    this.selectedIndex = i
                    this.feedback = this.myContent.answer_list[i].feedback
                    this.checkAnswer()
                    return
                }
            }            
        },
        showHelp() {
            this.$store.commit('setShowHelpEvent', false)
            this.showMyHelp = true
        },
        refresh() {
            this.$store.commit('setLanguageChanged',false)
            this.initData()
        },
        resetEvaluatedData() {
            this.feedback = null
            this.styleObject.color = 'black'
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>
</style>